import { Box, SxProps, Theme } from '@mui/material'
import React from 'react'

const LICENSE_ACCEPT = 'image/*,.pdf,application/pdf'

export const isDriverLicensePdf = (
  urlOrPath?: string | null,
  file?: File | null,
): boolean => {
  if (file) {
    if (file.type === 'application/pdf') return true
    if (/\.pdf$/i.test(file.name)) return true
  }
  if (!urlOrPath) return false
  return /\.pdf(\?|$)/i.test(urlOrPath)
}

/** Resolve contentType for license upload API from a File. */
export const getDriverLicenseUploadContentType = (file: File): string => {
  if (file.type) return file.type
  if (/\.pdf$/i.test(file.name)) return 'application/pdf'
  return 'image/jpeg'
}

export const DRIVER_LICENSE_FILE_ACCEPT = LICENSE_ACCEPT

interface DriversLicensePreviewProps {
  url: string
  isPdf?: boolean
  maxHeight?: number
  alt?: string
  sx?: SxProps<Theme>
}

/**
 * Renders a driver's license preview as an image or PDF iframe.
 */
const DriversLicensePreview: React.FC<DriversLicensePreviewProps> = ({
  url,
  isPdf = false,
  maxHeight = 280,
  alt = "Driver's license front",
  sx,
}) => {
  if (isPdf) {
    return (
      <Box
        component='iframe'
        src={url}
        title={alt}
        sx={{
          width: '100%',
          height: maxHeight,
          border: 'none',
          borderRadius: 1,
          bgcolor: 'grey.100',
          ...sx,
        }}
      />
    )
  }

  return (
    <Box
      component='img'
      src={url}
      alt={alt}
      sx={{
        width: '100%',
        maxHeight,
        objectFit: 'contain',
        borderRadius: 1,
        bgcolor: 'grey.100',
        ...sx,
      }}
    />
  )
}

export default DriversLicensePreview
